import type { ErrorMessage } from '../../lib/api.js';
import { formatNumber } from '../../lib/formatters.js';
import { AuthMiniBar } from './AuthMiniBar.js';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business エラーメッセージ TOP30 テーブルの 1 行。errorMessage / screen / event / count / uniqueSessions / loggedIn vs anonymous を描画する。
 * @graph-connects formatNumber [calls] 数値フォーマット
 * @graph-connects AuthMiniBar [calls] ログイン状態別ミニバー描画
 */
export function ErrorMessageRow({ msg }: { msg: ErrorMessage }) {
  return (
    <tr className="border-b border-[var(--color-border)] hover:bg-[var(--color-bg-hover)]">
      <td className="py-1.5 px-2 text-[var(--color-text-primary)] max-w-[400px]">
        <span className="block truncate" title={msg.errorMessage}>
          {msg.errorMessage}
        </span>
      </td>
      <td className="py-1.5 px-2 text-[var(--color-text-secondary)] whitespace-nowrap">
        {msg.screen}
      </td>
      <td className="py-1.5 px-2 text-[var(--color-text-secondary)] whitespace-nowrap">
        {msg.event}
      </td>
      <td className="py-1.5 px-2 text-right font-mono text-[var(--color-text-primary)]">
        {formatNumber(msg.count)}
      </td>
      <td className="py-1.5 px-2 text-right font-mono text-[var(--color-text-muted)]">
        {formatNumber(msg.uniqueSessions)}
      </td>
      <td className="py-1.5 px-2">
        <AuthMiniBar loggedIn={msg.loggedInCount} anonymous={msg.anonymousCount} />
      </td>
    </tr>
  );
}
